// Base
import React from "react";

//Assets
import paypalIcon from "@/assets/paypal-new.svg";

// Store
import { useTemplateStore } from "@/zustand/templateStore";

interface PaypalButtonProps {
  handlePaypalSubmit: () => void | Promise<void>;
  className?: string;
  icon?: string;
  height?: number;
}

const PaypalButton: React.FC<PaypalButtonProps> = ({
  handlePaypalSubmit,
  className,
  icon,
  height,
}) => {
  const { handlePaymentMethodChange } = useTemplateStore();

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await handlePaypalSubmit();
    handlePaymentMethodChange("paypal");
  };

  return (
    <button
      onClick={handleSubmit}
      formNoValidate
      type="button"
      className={className}
    >
      <img
        src={icon ?? paypalIcon}
        alt="PayPal"
        className={`mx-auto md:max-w-none ${height ? `h-[${height}px]` : "h-8"}`}
      />
    </button>
  );
};

export default PaypalButton;
